var Barba = require('barba.js');

exports.OpacityTransition = Barba.BaseTransition.extend({
    start: function () {
        $('.header__nav-li').removeClass('header__nav-li_active');
        this.newContainerLoading.then(this.fadeIn.bind(this));
        $('body').removeClass('body--active-modal mobile-navigation-active');
    },

    fadeIn: function () {
        var _this = this;
        var $new = $(this.newContainer),
            $old = $(this.oldContainer),
            scroll = document.documentElement.scrollTop || document.body.scrollTop;

        $new.css({ position: 'absolute', top: scroll + 'px', opacity: 0, visibility: 'visible' });

        Promise.all([
            setTimeout(function () {
                $new.animate({ opacity: 1 }, 250).promise();
            }, 250),
            $old.animate({ opacity: 0 }, 250).promise()
        ]).then(function () {
            $new.css({ position: '', top: '' });
            document.documentElement.scrollTop = document.body.scrollTop = 0;
            _this.done();
            if ($(window).width() < 600 && $('.header__menu').hasClass('header__menu_open') == true) {
                $('.header__menu').removeClass('header__menu_open');
                $('.blackout').removeClass('blackout_show');
                $('.modal-window_action').removeClass('modal-window_show');
            }
        });

        console.log(window.location.pathname);

        $('.header__nav-li').each(function(){
            let url = $(this).find('.header__nav-a').attr('href');

            if(window.location.pathname == url){
                $(this).addClass('header__nav-li_active');
            }
        });
        
    }
});



// WEBPACK FOOTER //
// resources/assets/src/js/transitions.js